import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";

import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import CheckWebP from "../Common/CheckWebP";
import BackImage from "../Media/back12.jpg";
import BackImageWebP from "../Media/back12.webp";
import LogoImage from "../Media/logoGravel.png";
import LogoImageWebP from "../Media/logoGravel.webp";
import DecorImage from "../Media/decorUp.png";
import DecorImageWebP from "../Media/decorUp.webp";

import { rulesAndInfo } from "../Variables/rulsAndInfo.jsx";
import ReactGA from "react-ga";

const styles = (theme) => ({
  chartDiv: {
    position: "relative",
    height: "50vh",
  },
  cardHeader: {},
  cardContent: {
    padding: 0,
  },
  avatar: {
    backgroundColor: theme.palette.secondary.color["500"],
  },
  body1: {
    padding: 5,
  },
  textHeaders: {
    padding: 16,
  },
  media: {
    minHeight: 500,
  },
  logo: {
    height: "auto",
    width: "50%",
  },
  decor: {
    marginBottom: "-7px",
  },
  expensionPanel: {
    backgroundColor: theme.palette.white70,
  },
});

function WelcomeCard(props) {
  const { classes, nextEvent } = props;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <CardMedia
          className={classes.media}
          image={CheckWebP() ? BackImageWebP : BackImage}
        >
          <CardHeader
            subheader={
              <Typography variant="h6" color="primary">
                <i>
                  {/* <small> Next event: </small> Monday,{" "}
                  {nextEvent.format("MMMM Do")} @ 5:00PM
                  <br /> */}
                  <small style={{ color: "red" }}>
                    {" "}
                    GGC5K is temporally suspended due to COVID19{" "}
                  </small>
                </i>
              </Typography>
            }
            className={classes.cardHeader}
          />
          <picture>
            <source srcSet={LogoImageWebP} type="image/webp" />
            <img src={LogoImage} alt="Logo" className={classes.logo} />
          </picture>

          <ExpansionPanel className={classes.expensionPanel}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component={"h4"}>
                {
                  "The Gaborone Golf Club 5k (“GGC5K“) is a weekly free to enter and timed 5k event. We encourage families and children to join. It is not a race but you will be able to compare your times to your previous efforts, those in your age group as well as everyone else that is taking part. It’s all about being part of a like minded community that enjoys exercise. You can walk, jog or run. We hope to see you at the Golf Club."
                }
                <ul>
                  <li>
                    <div style={{ color: "red" }}>
                      {" "}
                      GGC5K is temporally suspended please check updates here or
                      on our facebook page{" "}
                    </div>
                    {/* Next <b>weekly</b> event on:{" "}
                    {nextEvent.format("MMMM Do, YYYY")} at 5:30PM */}
                  </li>
                  <li>
                    {"Event location: "}
                    <a
                      href="https://goo.gl/maps/NPgMLdjSUc62"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Gaborone Golf Club
                    </a>
                  </li>
                  <li>
                    You can checkout the events pictures at{" "}
                    <ReactGA.OutboundLink
                      eventLabel="toFacebook"
                      to="https://www.facebook.com/GGC5K/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      GGC5K Facebook
                    </ReactGA.OutboundLink>{" "}
                    page
                  </li>
                  <li>{"Register today!"}</li>
                </ul>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    component={"div"}
                    className={classes.textHeaders}
                    variant={"h5"}
                  >
                    The Gaborone Golf Course 5kms Event Rules and General
                    Information
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  {rulesAndInfo.map((row, index) => {
                    return row === "The Course" ||
                      row === "The Run" ||
                      row === "Results" ||
                      row === "General Event Advice" ? (
                      <Typography
                        variant="h6"
                        className={classes.textHeaders}
                        key={index}
                      >
                        {row}
                      </Typography>
                    ) : (
                      <Typography key={index}>{row}</Typography>
                    );
                  })}
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <img
            src={CheckWebP() ? DecorImageWebP : DecorImage}
            className={classes.decor}
            alt={"decor"}
          />
        </CardMedia>
      </CardContent>
    </Card>
  );
}

WelcomeCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WelcomeCard);
